import React, { useEffect, useState } from 'react';
import { Box, Center, Spinner, Text, VStack, Button } from '@chakra-ui/react';
import { PartnerSSOAPI } from '../services/api';
import { clearTenantSessionStorage, setTenantUuid, setUserId } from '../utils/storage';

const sanitizeRedirectPath = (path) => {
  const value = (path || '/app').trim();
  if (!value.startsWith('/app') || value.startsWith('//')) return '/app';
  return value;
};

const PartnerLogin = () => {
  const [error, setError] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    if (!token) {
      setError('请返回 OneSuite，重新打开 Bizsprite。 / Return to OneSuite and open Bizsprite again.');
      return;
    }

    window.history.replaceState({}, document.title, window.location.pathname);

    (async () => {
      try {
        const data = await PartnerSSOAPI.exchange(token);
        clearTenantSessionStorage();
        localStorage.setItem('authToken', data.token);
        localStorage.setItem('userRole', data.role);
        setUserId(data.user_id);
        if (data.tenant_uuid) {
          setTenantUuid(data.tenant_uuid);
          localStorage.removeItem('tenant_name');
        }
        window.location.replace(sanitizeRedirectPath(data.redirect_path));
      } catch (err) {
        setError('本次自动登录未完成，请返回 OneSuite 重新打开 Bizsprite，或使用账号登录。 / Return to OneSuite and open Bizsprite again, or sign in with your account.');
      }
    })();
  }, []);

  return (
    <Center minH="100vh" bg="gray.50" px={6}>
      <Box bg="white" border="1px" borderColor="gray.200" borderRadius="md" p={8} maxW="420px" w="full">
        <VStack spacing={4}>
          {!error ? (
            <>
              <Spinner color="blue.500" />
              <Text fontWeight="semibold">Signing you in...</Text>
              <Text fontSize="sm" color="gray.500" textAlign="center">
                Please wait while Bizsprite verifies your secure login link.
              </Text>
            </>
          ) : (
            <>
              <Text fontWeight="semibold" color="red.600">Automatic login failed</Text>
              <Text fontSize="sm" color="gray.600" textAlign="center">{error}</Text><Button as="a" href="/login">账号登录 / Sign in</Button>
            </>
          )}
        </VStack>
      </Box>
    </Center>
  );
};

export default PartnerLogin;
